import $ from 'jquery';

const openSearch = () => {
    $('.search-box').addClass('open');
    $('#app-search-input').trigger('focus');
};

const closeSearch = () => {
    $('.search-box').removeClass('open');
};

$('#open-search-button').on('click', openSearch);
$('#close-search-button').on('click', closeSearch);

let debounceTimeout;

$(window).on('load', () => {
    $('.search-box').addClass('ready');
});

$('#app-search-input').on('input', function () {
    const searchTerm = $(this).val();

    clearTimeout(debounceTimeout);

    if (searchTerm.length < 2) return;

    debounceTimeout = setTimeout(function () {
        $.ajax({
            url: '/wp-admin/admin-ajax.php',
            type: 'POST',
            dataType: 'json',
            data: {
                action: 'verenza_search',
                s: searchTerm,
            },
            success(response) {
                if (response.success) {
                    $('#search-results').html(response.data);
                }
            },
        });
    }, 350);
});
